import { createContext } from "react";
import type { SetSearchTextContextType } from "../SearchTextProvider.types";

const SetSearchTextContext = createContext<SetSearchTextContextType | undefined>(undefined);
SetSearchTextContext.displayName = "SetSearchTextContext";

export default SetSearchTextContext;
